export const MINERU_PARSE_API = 'https://app.gaozhuan.net/mineru-api/parse-sync'

export const PARSEABLE_FILE_EXTS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp']

export const PARSEABLE_FILE_ACCEPT = '.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp,.bmp,image/*'

export function getFileExtFromName(name) {
  const base = (name || '').split('?')[0]
  const fileName = base.split('/').pop() || base
  const dot = fileName.lastIndexOf('.')
  return dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : ''
}

export function isParseableFileName(name) {
  return PARSEABLE_FILE_EXTS.includes(getFileExtFromName(name))
}

export function resolveRemoteFileUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  return `https://www.gaozhuan.net${url.startsWith('/') ? '' : '/'}${url}`
}

export async function parseFileToMarkdown(file) {
  const formData = new FormData()
  formData.append('file', file)

  const res = await fetch(MINERU_PARSE_API, {
    method: 'POST',
    body: formData,
  })
  const data = await res.json().catch(() => ({}))

  if (!res.ok || data.status !== 'completed') {
    throw new Error(data.message || '解析失败')
  }

  return (data.md_content || '').trim()
}

export async function parseRemoteFileToMarkdown(sourceUrl) {
  const fileUrl = resolveRemoteFileUrl(sourceUrl)
  const fileName = fileUrl.split('?')[0].split('/').pop() || 'document'

  const fileRes = await fetch(fileUrl)
  if (!fileRes.ok) {
    throw new Error('无法获取原文件')
  }

  const blob = await fileRes.blob()
  const file = new File([blob], fileName, { type: blob.type || 'application/octet-stream' })
  return parseFileToMarkdown(file)
}
